export const buildFavoriteItemPatch = (itemIds) => {
  const patchData = {
    data: {
      type: "current-user",
      attributes: {
        "favorite-item-ids": itemIds,
      },
    },
  };

  return patchData;
};
